import React, { useState } from 'react'
import { Box, Typography, Button, Dialog, DialogTitle, DialogContent, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import CustomButton from '../customComponents/CustomButton';

export interface educationDto {
  school?: string;
  degree?: string;
  address?: string;
  field?: string;
  fieldOfStudy?: string;
  fieldOfStudyFull?: string;
  startDate?: string;
  endDate?: string;
  grade?: string;
  activitiesAndSocieties?: string;
  description?: string;
  webAddress?: string;
  png: string;
}


export const educationData: educationDto[] = [
  {
    field: "IT Engineering - BE",
    grade: "Bachelor of Engineering",
    school: "University of Applied Science and Technology",
    degree: "3.1/4",
    address: "Tehran",
    fieldOfStudy: "Information Technology",
    fieldOfStudyFull: "Information Technology - Electronic commerce",
    endDate: "Feb 2015",
    description: "Electronic commerce, Concept of Software Engineering, Database, Algorithm design, Computer architecture, Logic circuit, data structure, Business Intelligence, E-Commerce Security, Electronic marketing, Programming language: C++, C#, VB",
    webAddress: "https://www.acmt.ac.ir/",
    png: "universityOfAppliedScienceAndTechnology"
  }
];


export interface certificateDto {
  title: string;
  institution: string;
  address: string;
  endDate: string;
  png: string;
  link?: string;
  showFirst?: boolean;
}


export const certificateData: certificateDto[] = [
  {
    title: "Advanced React",
    institution: "Meta",
    address: "Coursera",
    endDate: "June 2025",
    png: "meta",
    link: 'https://coursera.org/verify/7T7UA4PLT6Z9',
    showFirst: true,
  },
  {
    title: "React Basics",
    institution: "Meta",
    address: "Coursera",
    endDate: "July 2025",
    png: "meta",
    link: 'https://coursera.org/verify/LJDF9AAH4XK1'
  },
  {
    title: "Programming with JavaScript",
    institution: "Meta",
    address: "Coursera",
    endDate: "July 2025",
    png: "meta",
    link: 'https://coursera.org/verify/YZ0NSEULZU8C',
    showFirst: true,
  },
  {
    title: "HTML and CSS in depth",
    institution: "Meta",
    address: "Coursera",
    endDate: "July 2025",
    png: "meta",
    link: 'https://coursera.org/verify/0QLKHPEU998H',
  },
  {
    title: "Version Control",
    institution: "Meta",
    address: "Coursera",
    endDate: "July 2025",
    png: "meta",
    link: 'https://coursera.org/verify/5WNA82YTTBDN'
  },
  {
    title: "Introduction to Front-End Development",
    institution: "Meta",
    address: "Coursera",
    endDate: "July 2025",
    png: "meta",
    link: 'https://coursera.org/verify/0ZLNTJCF94T5'
  },
  {
    title: "Learn Typescript",
    institution: "Scrimba",
    address: "Coursera",
    endDate: "July 2025",
    png: "scrimba",
    link: 'https://coursera.org/verify/NKVY11EMYU9O'
  },
  {
    title: "Redux in JavaScript and React",
    institution: "Scrimba",
    address: "Coursera",
    endDate: "July 2025",
    png: "scrimba",
    link: 'https://coursera.org/verify/LBMSNW9Z8RVR',
  },
  {
    title: "Google Agile Essentials",
    institution: "Google",
    address: "Coursera",
    endDate: "July 2025",
    png: "google",
    link: 'https://coursera.org/verify/19QE3WSNKW8Q',
    showFirst: true,
  },
  {
    title: "Back-End Development with .NET",
    institution: "Microsoft",
    address: "Coursera",
    endDate: "July 2025",
    png: "microsoft",
    link: 'https://coursera.org/verify/RKE1BAX6YJY2',
    showFirst: true,
  },
  {
    title: "Database Integration and Management",
    institution: "Microsoft",
    address: "Coursera",
    endDate: "July 2025",
    png: "microsoft",
    link: 'https://coursera.org/verify/PZYGLOUBH0A0',
  },
  {
    title: "Intro to Web Programming",
    institution: "Athabasca University",
    address: "Alberta",
    endDate: "December 2024",
    png: "athabasca",
  }
];

const EducationItem: React.FC<{ index: number; title: string; description: string; png: string; link?: string, showDescription?: boolean; }> = ({ index, title, description, png, link, showDescription = true }) => {
  const itemContent = (
    <Box display='flex' flexDirection='row' justifyContent='flex-start' alignItems='center' marginBottom='15px' >
      <Box paddingRight='10px' height='52px' display='flex' alignItems='center'>
        <img
          key={index}
          src={`${process.env.PUBLIC_URL}/education/${png}.png`}
          alt={`Logo frame ${index}`}
          style={{
            width: '40px',
            height: 'auto',
            maxHeight: '52px'
          }}
        />
      </Box>
      <Box key={index} >
        <Typography variant='body1' sx={{ fontWeight: "bold" }}  >
          {title}
        </Typography>
        {/* <Typography variant='body2' >
          {institution}
        </Typography> */}
        {showDescription && <Typography variant='caption' >{description}</Typography>}
      </Box>
    </Box>
  );
  if (link) {
    return (
      <a href={link} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', color: 'inherit' }}>
        {itemContent}
      </a>
    );
  }
  return itemContent;
}

const Education: React.FC = () => {
  const [openDialog, setOpenDialog] = useState(false);

  const sectionId = 'homeEducation'

  return (
    <Box
      component="section"
      id={sectionId}
      sx={{
        position: 'relative',
        width: '100vw',
        backgroundAttachment: { xs: 'scroll', md: 'fixed' },
        backgroundPosition: 'left',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundImage: `url(education.jpg)`,
        height: { xs: '100vh', md: '100vh' },
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}
    >
      <Box sx={{
        backgroundColor: '#dde3e1',
        height: 'auto',
        width: { xs: '86%', md: '50%', xl: '40%' },
        padding: { xs: '15px', md: '40px' },
        borderRadius: '10px'

      }} >
        <Typography variant="h4" align="center"
          sx={{
            fontWeight: "bold",
            paddingTop: '10px',
            paddingBottom: '20px',
            width: '100%'
          }} >
          certificates
        </Typography>
        {certificateData.filter(item => item.showFirst).map((item, index) => (
          <EducationItem key={index} index={index} title={item.title} description={`${item.institution} - ${item.address} - ${item.endDate}`} png={item.png} link={item.link} />
        ))}
        <Box textAlign="end" marginBottom="20px">
          <CustomButton
            lable='Show More'
            type='button'
            size='medium'
            infoContent='Show More'
            disabled={false}
            onClick={() => setOpenDialog(true)}
          />
        </Box>
        <Typography variant="h4" align="center"
          sx={{
            fontWeight: "bold",
            paddingTop: '20px',
            paddingBottom: '20px',
            width: '100%'
          }} >
          Educations
        </Typography>
        {educationData.map((item, index) => (
          <EducationItem key={index} index={index} title={`${item.grade} in ${item.fieldOfStudy}`} description={`${item.school} - ${item.address} - ${item.endDate}`} png={item.png} />
        ))}
      </Box>
      <Dialog open={openDialog} onClose={() => setOpenDialog(false)} fullWidth maxWidth="sm">
        <DialogTitle sx={{ m: 0, p: 2, backgroundColor: '#c4d0ce', }}>
          All Certificates
          <IconButton
            aria-label="close"
            onClick={() => setOpenDialog(false)}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers
          sx={{ backgroundColor: '#dde3e1' }}
        >
          {certificateData.map((item, index) => (
            <EducationItem key={index} index={index} title={item.title} description={`${item.institution} - ${item.address} - ${item.endDate}`} png={item.png} link={item.link} />
          ))}
        </DialogContent>
      </Dialog>
    </Box>
  )
}

export default Education;